import { render } from "./SportsBar.vue?vue&type=template&id=b23992c6&scoped=true"
import script from "./SportsBar.vue?vue&type=script&lang=js"
export * from "./SportsBar.vue?vue&type=script&lang=js"

import "./SportsBar.vue?vue&type=style&index=0&id=b23992c6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b23992c6"]])

export default __exports__